import React, { useState } from 'react';
import { Button, Input, Modal } from '../../../../components';
import { useChangeUserPassword } from '../../hooks/useChangeUserPassword';
import { password } from '../../icons';

type RenameUserProps = {
  open: boolean;
  onClose: () => void;
};

export const ChangeUserPassword: React.FC<RenameUserProps> = ({
  open,
  onClose,
}: RenameUserProps): JSX.Element => {
  const {
    values,
    handleChange,
    handleSubmit,
    handleCancel,
    touched,
    errors,
  } = useChangeUserPassword(onClose);

  const [isSuccess, setIsSuccess] = useState(false);

  const onClickGoIt = () => {
    handleCancel();
    setIsSuccess(false);
  };

  const verifyErr = () => {
    let error;
    if (touched.password) error = errors.password;
    else if (!values.isVerified && values.errIncorPassword)
      error = values.errIncorPassword;
    return error;
  };

  const condErrMismatch = () => {
    let error;
    if (touched.password) error = errors.password;
    else if (values.password !== values.confirmPassword)
      error = 'Passwords mismatch';
    return error;
  };

  const conditionTodisableSave = values.password !== values.confirmPassword;

  return (
    <Modal title="Change password" open={open} onClose={onClickGoIt}>
      <div className={`edit-user edit-user-${open ? 'open' : 'closed'}`}>
        <form onSubmit={handleSubmit}>
          {!values.isVerified ? ( // eslint-disable-line
            <>
              <Input
                type="password"
                label="OLD PASSWORD"
                value={values.password}
                onChange={handleChange}
                name="password"
                icon={password}
                className="edit-user__input"
                error={verifyErr()}
                disabled={false}
              />
              <Button
                type="submit"
                className={
                  verifyErr() ? 'err edit-user__btn' : 'edit-user__btn'
                }
                variant="common"
              >
                Continue
              </Button>
            </>
          ) : !isSuccess ? (
            <>
              <Input
                type="password"
                label="NEW PASSWORD"
                value={values.password}
                onChange={handleChange}
                name="password"
                icon={password}
                className="edit-user__input"
                error={condErrMismatch()}
                disabled={false}
              />
              <div
                className={
                  condErrMismatch()
                    ? 'err edit-user__change-pass-notice'
                    : 'edit-user__change-pass-notice'
                }
              >
                <span className="edit-user__change-pass-notice__light">
                  Password strength:
                </span>{' '}
                Use at least 8 characters. Don’t use a password from another
                site, or something too obvious like your pet’s name.{' '}
              </div>
              <Input
                type="password"
                label="CONFIRM NEW PASSWORD"
                value={values.confirmPassword}
                onChange={handleChange}
                name="confirmPassword"
                icon={password}
                className="edit-user__input"
                error={condErrMismatch()}
                disabled={false}
              />
              <Button
                type="submit"
                className={
                  condErrMismatch() ? 'err edit-user__btn' : 'edit-user__btn'
                }
                variant="common"
                disabled={conditionTodisableSave}
                onClick={() => {
                  setIsSuccess(true);
                }}
              >
                Save
              </Button>
            </>
          ) : (
            <>
              <div>Password was successfully changed</div>
              <Button
                onClick={onClickGoIt}
                className="edit-user__btn"
                variant="common"
              >
                Got it
              </Button>
            </>
          )}
        </form>
      </div>
    </Modal>
  );
};
